import { configureStore } from "@reduxjs/toolkit";
import roomSlice from "./slices/room/roomSlice";
import wheelSlice from "./slices/wheel/wheelSlice";
import bookingSlice from "./slices/booking/bookingSlice";
import productSlice from "./slices/product/productSlice";
import adsSlice from "./slices/ads/adsSlice";
import ratingSlice from "./slices/rating/ratingSlice";
import userSlice from "./slices/user/userSlice";

export const store = configureStore({
  reducer: {
    room: roomSlice,
    wheel: wheelSlice,
    booking: bookingSlice,
    product: productSlice,
    ads: adsSlice,
    rating: ratingSlice,
    user: userSlice,
  },
});
